import { graphql } from '@apollo/client/react/hoc';
import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { compose, lifecycle, mapProps, withProps, withState } from 'recompose';
import { withRouter } from 'react-router-dom';
import merge from 'lodash/merge';
import update from 'lodash/update';
import { isDefinedAndNotNull, isFunction, isObject } from '@/se/utilities/check';
import LinkButton from '@/se/components/LinkButton';
import Button from '@/se/components/Button[DEPRECATED]';
import waiting from '../../../../assets/images/waiting.svg';
import { PROCEDURE_STATUSES, STATUSES as PATIENT_STATUSES } from '../../../entities/patient/enums';
import { ROOM_TYPES, STATUSES as ROOM_STATUSES } from '../../../entities/room/enums';
import { getPatientProcedureDuration, transformORPatients } from '../../../entities/patient/transducers';
import { mapTabletOperationRoom } from '../../../entities/room/transducers';
import Mousetrap from 'mousetrap';
import { get, throttle } from 'lodash';
import { format } from 'date-fns';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import {
  completeCleaning,
  markAsComplete,
  opreationRoomSubscription,
  patientReadyInOR,
  skipCleaning,
  startClosing,
  startDressingOn,
  startProcedure,
  startTimeout,
  turnoverClockOff,
} from '@/graph/rooms';
import {
  exitProcedure,
  resetProcedure,
  setFlipRoom,
  setRoom as setRoomForPatient,
  setUndoFlipRoom,
  startAdditionalTimeout,
} from '../../../../graph/patients';

import ProcedureProgress from './ProcedureProgress';
import CurrentStatusHeader from './CurrentStatusHeader';
import { ButtonLabel, Label, MainButton, TimeOut2Button, TimeOutButton } from './common';
import {
  eventTime,
  getLogEntries,
  isFlipRoomFn,
  isHelpFn,
  isOrTimeActive,
  optionalFormat,
  patientEnteredTime,
  showValueIf,
} from './utils';
import { patientEnteredRoomTypeTime } from '../../../entities/patient/util/patientEvents';
import CleaningClock from './CleaningClock';
import { H3 } from '@/se/components/typography';
import WallClock from './WallClock';
import ClientUpdater from '../../../ClientUpdater';
import TimeEditModal, { OR_TIMES, OR_TIMES_S } from '../../../inputs/timeEdit/TimeEditModal';
import EditTimeIcon from '../../../inputs/timeEdit/EditTimeIcon';
import Troubleshooting from './Troubleshooting/Troubleshooting';
import { CenteredSpinner } from '@/se/components/Spinner';
import responsive from '@/se/utilities/responsive';

import prevSound from '../../../../assets/sound/discharge.mp3';
import nextSound from '../../../../assets/sound/orReady.mp3';
import { Exit, Modal, ModalAction, Subtitle, Title } from './Modal';
import PatientSelection from '../nursingApp/PatientSelection';
import { getProcedures as getProcedureCards } from '../schedule/transform';
import { useMutation, useSubscription } from '@apollo/client';
import { listSubscription as listProceduresSubscription } from '../../../../graph/procedures';
import { useWebSocketReconnect } from '@/hooks/useWebSocketReconnect';
import { useToaster } from '@/components/core/Toaster';
import Procedure from '../schedule/overview/Procedure';
import Box from '@material-ui/core/Box';
import Slide from '@material-ui/core/Slide';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Divider from '@material-ui/core/Divider';
import { getNextScheduledProcedures } from './procedures';
import { getRemainingScheduledProcedures } from './proceduresRemaining';
import { Alert } from '@material-ui/lab';
import { RefreshRounded, RingVolume } from '@material-ui/icons';
import { ButtonBase, Checkbox, FormControlLabel, SvgIcon } from '@material-ui/core';
import { setHelp, setUndoHelp } from '@/graph/patients';
import clsx from 'clsx';
import { getNestedValue } from '@/se/utilities/data/object';
import { playSound } from '@/components/pages/kiosk/monitor/hooks/useAlerts';
import { useScreenConfiguration } from '@/contexts/ScreenConfigurationContext';

const MessageToSend = styled.p`
  position: relative;
  padding: 1em 1.5em;
  border-radius: .25em;
  margin-bottom: 4rem;
  font-size: 1.75rem;
  line-height: 1.5;
  background-color: ${props => props.theme.textColor.alpha(0.2).string()};
  max-width: 30em;
  text-align: left;

  :before {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    border-left: 10px solid transparent;
    border-right: 10px solid ${props => props.theme.textColor.alpha(0.2).string()};
    border-top: 10px solid ${props => props.theme.textColor.alpha(0.2).string()};
    border-bottom: 10px solid transparent;
    right: 19px;
    bottom: -20px;
}
  }
`;

const Root = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  background: ${props => props.theme.backgroundColor.string()};
  color: ${props => props.theme.textColor.string()};
  grid-template-columns: minmax(min-content, 0) auto;
  min-height: 100vh;
  font-family:
    -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol';

  ${responsive.sm.andSmaller`
    display: flex;
    overflow: hidden;
  `};
`;

export const Idle = styled.div`
  margin-top: auto;
  margin-bottom: auto;
  text-align: center;
  grid-column: 1 / span 2;
`;

export const Illustration = styled.img`
  max-width: 6rem;
`;

export const Supertitle = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  margin-top: 1.5rem;
  opacity: 0.5;

  @media (min-width: 50rem) {
    font-size: 1.25rem;
  }
`;

const SubtleLink = styled(LinkButton)`
  color: inherit;
  opacity: 0.5;
  margin-bottom: 0.5rem;
`;

const RoomName = styled.span`
  margin-top: 0;
  text-align: right;
  opacity: 0.5;
  font-size: 0.875rem;
`;

const Actions = styled.div`
  display: flex;
  padding: 0 1.75rem;

  ${responsive.sm.andSmaller`
    flex-flow: column-reverse;
    padding: 0 .25rem;
  `};
`;

const ActionsAlt = styled(Actions)`
  grid-column: 1 / span 2;
  padding-bottom: 2.5rem;
`;

export const CustomModal =
  (message, yesPrimary = true, yesLabel, yesSecondaryLabel, noLabel) =>
  ({
    handleConfirm,
    handleSecondaryConfirm,
    handleCancel,
    working,
    sendTo,
    messageToSend,
    errorMessage,
    physicianLastPatient,
  }) => (
    <Modal
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
      }}
      style={{ overflowY: 'unset' }}
    >
      <Title>Are you sure?</Title>
      <Subtitle>
        {message}{' '}
        {!!sendTo && (
          <span>
            <br />
            {sendTo}
          </span>
        )}
      </Subtitle>
      {!!messageToSend && <MessageToSend>{messageToSend}</MessageToSend>}
      <ModalAction>
        {physicianLastPatient ? (
          <>
            <Button xl primary onClick={handleConfirm} disabled={working}>
              <WithWorking working={working}>Discharge and Send</WithWorking>
            </Button>
            <Button xl primary={!yesPrimary} onClick={handleSecondaryConfirm} disabled={working}>
              <WithWorking working={working}>Discharge</WithWorking>
            </Button>
          </>
        ) : (
          <>
            <Button xl primary={yesPrimary} onClick={handleConfirm} disabled={working}>
              <WithWorking working={working}>{yesLabel || 'Yes'}</WithWorking>
            </Button>
            {handleSecondaryConfirm && (
              <Button xl primary={yesPrimary} onClick={handleSecondaryConfirm} disabled={working}>
                <WithWorking working={working}>{yesSecondaryLabel || 'Yes'}</WithWorking>
              </Button>
            )}
          </>
        )}
        <Button xl primary={!yesPrimary} onClick={handleCancel} disabled={working}>
          {noLabel || 'No'}
        </Button>
      </ModalAction>
      {!!errorMessage && (
        <Alert severity="error" style={{ marginTop: 40 }}>
          {errorMessage}
        </Alert>
      )}
    </Modal>
  );

export const TransferModal =
  (message, yesPrimary = true, yesLabel, yesSecondaryLabel, noLabel) =>
  ({
    handleConfirm,
    handleSecondaryConfirm,
    handleCancel,
    working,
    sendTo,
    messageToSend,
    errorMessage,
    physicianLastPatient,
  }) => (
    <Modal
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
      }}
      style={{ overflowY: 'unset' }}
    >
      <Title>
        {message}
        <br></br>Are you sure?
      </Title>

      <Subtitle>{!!sendTo && <span>{sendTo}</span>}</Subtitle>
      <br></br>
      {!!messageToSend && <MessageToSend>{messageToSend}</MessageToSend>}
      <ModalAction>
        {physicianLastPatient ? (
          <>
            <Button xl primary onClick={handleConfirm} disabled={working}>
              <WithWorking working={working}>Discharge and Send</WithWorking>
            </Button>
            <Button xl primary={!yesPrimary} onClick={handleSecondaryConfirm} disabled={working}>
              <WithWorking working={working}>Discharge</WithWorking>
            </Button>
          </>
        ) : (
          <>
            <Button xl primary={yesPrimary} onClick={handleConfirm} disabled={working}>
              <WithWorking working={working}>{yesLabel || 'Yes'}</WithWorking>
            </Button>
            {handleSecondaryConfirm && (
              <Button xl primary={yesPrimary} onClick={handleSecondaryConfirm} disabled={working}>
                <WithWorking working={working}>{yesSecondaryLabel || 'Yes'}</WithWorking>
              </Button>
            )}
          </>
        )}
        <Button xl primary={!yesPrimary} onClick={handleCancel} disabled={working}>
          {noLabel || 'No'}
        </Button>
      </ModalAction>
      {!!errorMessage && (
        <Alert severity="error" style={{ marginTop: 40 }}>
          {errorMessage}
        </Alert>
      )}
    </Modal>
  );

export const DischargeModal =
  (message, yesPrimary = false, yesLabel, yesSecondaryLabel, noLabel) =>
  ({ handleConfirm, handleSecondaryConfirm, handleCancel, working, sendTo, messageToSend, errorMessage }) => (
    <Modal
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
      }}
      style={{ overflowY: 'unset' }}
    >
      <Title>Please remove the patient’s bracelet and then click the 'Confirm' button to discharge the patient.</Title>
      <Subtitle>
        {message}{' '}
        {!!sendTo && (
          <span>
            <br />
            {sendTo}
          </span>
        )}
      </Subtitle>
      {!!messageToSend && <MessageToSend>{messageToSend}</MessageToSend>}
      <ModalAction>
        <Button xl primary={yesPrimary} onClick={handleConfirm} disabled={working}>
          <WithWorking working={working}>{yesLabel || 'Yes'}</WithWorking>
        </Button>
        {handleSecondaryConfirm && (
          <Button xl primary={yesPrimary} onClick={handleSecondaryConfirm} disabled={working}>
            <WithWorking working={working}>{yesSecondaryLabel || 'Yes'}</WithWorking>
          </Button>
        )}
        <Button xl primary={!yesPrimary} onClick={handleCancel} disabled={working}>
          {noLabel || 'No'}
        </Button>
      </ModalAction>
      {!!errorMessage && (
        <Alert severity="error" style={{ marginTop: 40 }}>
          {errorMessage}
        </Alert>
      )}
    </Modal>
  );

const DischargeLastPatient = CustomModal(`Send Physician daily recap message.`);

export const DischargeModalV2 = ({
  handleConfirm,
  handleCancel,
  working,
  patient,
  physicianLastPatient,
  physicianLastProcedureManual,
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const [showPhysicianModal, setShowPhysicianModal] = useState(false);

  const handleCheckboxChange = e => {
    e.stopPropagation();
    setIsChecked(e.target.checked);
  };

  const handleConfirmClick = () => {
    if (isChecked) {
      if (patient?.physicianLastPatient && physicianLastProcedureManual) {
        setShowPhysicianModal(true);
      } else {
        handleConfirm();
      }
    }
  };

  if (showPhysicianModal) {
    return (
      <DischargeLastPatient
        sendTo={`Message will be sent to ${patient?.physicianData?.name} at ${patient?.physicianData?.notificationNumbers?.split(',')}`}
        messageToSend="Hi {{physicianName}}, your last patient {{patientFullName}} was discharged at {{currentTime}}. Here are your analytics for the day: Average PIPO (Patient in Patient out): {{physicianPipoAvg}}, Average Surgery Time: {{physicianSurgeryTimeAvg}}, Average Closing Time: {{physicianClosingTimeAvg}}, Average Turnover: {{physicianTurnoverAvg}}."
        handleConfirm={handleConfirm}
        handleSecondaryConfirm={handleConfirm}
        handleCancel={() => setShowPhysicianModal(false)}
        physicianLastPatient={patient?.physicianLastPatient}
      />
    );
  }

  return (
    <Modal
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
      }}
      style={{ overflowY: 'unset' }}
    >
      <Title
        style={{
          fontSize: '3.5rem',
          textAlign: 'center',
          marginBottom: '2.5rem',
          fontWeight: 700,
          color: '#FF4842',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
        }}
      >
        Bracelet Removed?
      </Title>
      <Box display="flex" flexDirection="column" alignItems="center" mb={4}>
        <FormControlLabel
          control={
            <Checkbox
              checked={isChecked}
              onChange={handleCheckboxChange}
              color="primary"
              style={{ transform: 'scale(1.5)' }}
              onClick={e => e.stopPropagation()}
            />
          }
          label="I confirm that I have removed the patient's bracelet"
          style={{ fontSize: '1.2rem' }}
          onClick={e => e.stopPropagation()}
        />
      </Box>
      <ModalAction>
        <Button xl primary onClick={handleConfirmClick} disabled={working || !isChecked}>
          <WithWorking working={working}>Confirm Discharge</WithWorking>
        </Button>
        <Button xl onClick={handleCancel} disabled={working}>
          Cancel
        </Button>
      </ModalAction>
    </Modal>
  );
};

const ExitModal = CustomModal('Current procedure progress will be lost. This action cannot be reversed.');
const ClosingModal = CustomModal(
  'This action will start procedure closing and send SMS to the patient’s caretaker.',
  true
);

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 2rem 2.5rem;
  align-items: center;
  line-height: 1.25rem;

  > * {
    flex: 1;
  }

  ${responsive.sm.andSmaller`
    padding: 1rem 1.5rem;
  `};
`;

const SubtleActionWrapper = styled.div`
  background-color: transparent;
  flex: 1 0 calc(50% - 1.5rem);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  margin: 0 0.75rem 0;
  outline: none;
`;

const SubtleAction = styled(Exit)`
  display: ${props => (props.visible ? 'inline-block' : 'none')};
`;

const StatusWrapper = styled.div`
  margin: auto 0;
`;

const StatusWrapperAlt = styled(StatusWrapper)`
  position: relative;
  grid-column: 1 / span 2;
  margin: 0;
  margin-top: 5%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ClockWrapper = styled(StatusWrapper)`
  grid-column: 1 / span 2;
  margin: 0;
  margin-bottom: 3%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.75rem;
`;

const Text = styled.p`
  text-align: center;
  line-height: 1.4;
  opacity: 0.5;
  margin-bottom: 1rem;
`;

const useStyles = makeStyles(theme => ({
  dialogContent: {
    background: theme.palette.background.default,
    fontSize: '1.5em',
  },
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  helpButton: {
    backgroundColor: 'transparent',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    borderWidth: 4,
    borderStyle: 'solid',
    borderRadius: 8,
    borderColor: 'rgba(255,255,255,0.25)',
    height: '160%',
    minWidth: 180,
    position: 'relative',
    overflow: 'visible',
  },
  helpButtonActive: {
    backgroundColor: '#FF4842',
    '&:before': {
      content: '""',
      animation: `$myEffect 1500ms ${theme.transitions.easing.sharp} infinite`,
      display: 'block',
      position: 'absolute',
      height: '100%',
      width: '100%',
      backgroundColor: '#FF4842',
      transformOrigin: 'center center',
      borderRadius: 8,
      zIndex: -1,
    },
  },
  flipRoomButton: {
    backgroundColor: 'transparent',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    borderWidth: 4,
    borderStyle: 'solid',
    borderRadius: 8,
    borderColor: 'rgba(255,255,255,0.25)',
    height: '160%',
    minWidth: 180,
    position: 'relative',
    overflow: 'visible',
  },
  flipRoomButtonActive: {
    backgroundColor: '#768255',
    '&:before': {
      content: '""',
      animation: `$myEffect 1500ms ${theme.transitions.easing.sharp} infinite`,
      display: 'block',
      position: 'absolute',
      height: '100%',
      width: '100%',
      backgroundColor: '#768255',
      transformOrigin: 'center center',
      borderRadius: 8,
      zIndex: -1,
    },
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const WithWorking = ({ working, children, size = undefined }) => (
  <Box display="grid" alignItems="center">
    <Box gridRow={1} gridColumn={1} visibility={working ? 'visible' : 'hidden'} marginTop="-1.25em">
      <CenteredSpinner size={size} freezeAnimation={!working} />
    </Box>
    <Box gridRow={1} gridColumn={1} visibility={working ? 'hidden' : 'visible'}>
      {children}
    </Box>
  </Box>
);

const CurrentAction = ({
  nextProceduresInOperationRoom,
  action,
  status,
  patient,
  patientType,
  physician,
  procedureType,
  handleExitProcedureButtonClick,
  room,
}) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [working, setWorking] = useState({ back: false, forward: false });
  const { SubAction } = action;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const withWorking = (fn, key) => async args => {
    if (fn) {
      setWorking({ [key]: true });
      await fn(args);
      setWorking({ [key]: false });
    }
  };

  return (
    <Fragment>
      {!action.isHeaderHidden ? (
        <CurrentStatusHeader
          physician={physician}
          room={room}
          patient={patient}
          patientType={patientType}
          procedureType={procedureType}
          handleExitProcedureButtonClick={handleExitProcedureButtonClick}
          action={action}
        />
      ) : null}

      <Box display="flex" flex={1} flexDirection="column" id="drawer-container">
        <StatusWrapper>
          <ProcedureProgress status={status} room={room} action={action} />
        </StatusWrapper>

        <Actions>
          {!action.isSubtleAction && (
            <Fragment>
              <TimeOutButton onClick={withWorking(action.prev, 'back')} disabled={!action.prev || working.back}>
                <WithWorking working={working.back} size={'4rem'}>
                  <Box fontSize={'6.5em'}>
                    <ChevronLeftIcon fontSize={'inherit'} />
                  </Box>
                </WithWorking>
                <ButtonLabel>{'Undo'}</ButtonLabel>
              </TimeOutButton>

              <MainButton onClick={withWorking(action.next, 'forward')} disabled={working.forward}>
                <WithWorking working={working.forward} size={'4rem'}>
                  <Box fontSize={'6.5em'}>
                    <ChevronRightIcon fontSize={'inherit'} />
                  </Box>
                </WithWorking>
                <ButtonLabel>{action.nextLabel}</ButtonLabel>
              </MainButton>
            </Fragment>
          )}

          {action.isSubtleAction && (
            <SubtleActionWrapper>
              <H3 style={{ opacity: '.5', marginTop: 0 }}>No further action needed</H3>
              <Text>
                This procedure will be automatically marked as complete <br /> as soon as the patient leaves the room.
              </Text>
              <Exit style={{ minHeight: '1em' }} onClick={withWorking(action.prev, 'back')} disabled={working.back}>
                <WithWorking working={working.back}>Undo</WithWorking>
              </Exit>
              <SubtleAction
                onClick={withWorking(action.next, 'forward')}
                visible={action.isSubtleAction}
                disabled={working.forward}
              >
                <WithWorking working={working.forward}>{action.nextLabel}</WithWorking>
              </SubtleAction>
            </SubtleActionWrapper>
          )}
        </Actions>

        <Footer>
          {nextProceduresInOperationRoom && nextProceduresInOperationRoom.length > 0 ? (
            <Fragment>
              <Button variant="outlined" color="primary" onClick={handleClickOpen}>
                Next Procedures
              </Button>
              <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
                <AppBar color="inherit" className={classes.appBar}>
                  <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                      <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                      Next Procedures
                    </Typography>
                    <Button variant="contained" color="primary" onClick={handleClose}>
                      Back to the current procedure
                    </Button>
                  </Toolbar>
                </AppBar>
                <Box p={4} className={classes.dialogContent}>
                  {nextProceduresInOperationRoom.map((p, index) => (
                    <Box mb={2} key={index}>
                      <Procedure
                        onClick={undefined}
                        procedure={p}
                        isUnassigned={false}
                        date={new Date()}
                        isPatientIconVisible={true}
                        highContrast={true}
                      />
                    </Box>
                  ))}
                </Box>
              </Dialog>
            </Fragment>
          ) : (
            <div />
          )}
          <RoomName style={{ textAlign: 'center' }}>{room.name}</RoomName>
          {SubAction ? <SubAction /> : <span style={{ textAlign: 'right' }}>–</span>}
        </Footer>
      </Box>
    </Fragment>
  );
};

const TimeOutAction = ({ isTimeOutActive, mutate, patient }) => {
  const [working, setWorking] = useState(false);

  const handleButtonClick = async () => {
    try {
      if (isFunction(mutate) && isObject(patient)) {
        setWorking(true);
        await mutate({ variables: { id: patient.id } });
      }
    } catch (error) {
      console.error(error);
    }
    setWorking(false);
  };

  return (
    <TimeOut2Button onClick={handleButtonClick} disabled={working || isTimeOutActive}>
      <WithWorking working={working}> {isTimeOutActive ? 'Time Out 2 Started' : 'Start Time Out 2'} </WithWorking>
    </TimeOut2Button>
  );
};

const Times = styled.div`
  grid-column: 1 / 1;
  display: flex;
  flex-flow: column;
  border-right: 1px solid rgba(255, 255, 255, 0.25);

  > * + * {
    border-top: 1px solid rgba(255, 255, 255, 0.25);
  }

  ${responsive.sm.andSmaller`
    display: none;
  `};
`;

const Controls = styled.div`
  grid-column: 2 / 2;
  display: flex;
  flex-flow: column;
  height: 100vh;
  flex: 1;

  ${responsive.sm.andSmaller`
    height: 100%;
  `};
`;

const Entry = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-flow: column;
  justify-content: center;
  padding-left: 2.5rem;
  padding-right: 1rem;
`;

const Value = styled.div`
  font-size: 4.5rem;
  font-weight: 600;
  font-family: monospace;
  line-height: 1.2;

  > span {
    font-size: 1.2rem;
  }
`;

const LabelLarge = styled(Label)`
  font-size: 1.5rem;
  margin-bottom: 0;
`;

const TimeHeader = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const ActionWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: 2rem;
`;

function PersonAlert(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M26.6667 14.6667C26.2889 14.6667 25.9722 14.5389 25.7167 14.2833C25.4611 14.0278 25.3333 13.7111 25.3333 13.3333C25.3333 12.9556 25.4611 12.6389 25.7167 12.3833C25.9722 12.1278 26.2889 12 26.6667 12C27.0445 12 27.3611 12.1278 27.6167 12.3833C27.8722 12.6389 28 12.9556 28 13.3333C28 13.7111 27.8722 14.0278 27.6167 14.2833C27.3611 14.5389 27.0445 14.6667 26.6667 14.6667ZM26.6667 10.6667C26.2889 10.6667 25.9722 10.5389 25.7167 10.2833C25.4611 10.0278 25.3333 9.71111 25.3333 9.33333V5.33333C25.3333 4.95556 25.4611 4.63889 25.7167 4.38333C25.9722 4.12778 26.2889 4 26.6667 4C27.0445 4 27.3611 4.12778 27.6167 4.38333C27.8722 4.63889 28 4.95556 28 5.33333V9.33333C28 9.71111 27.8722 10.0278 27.6167 10.2833C27.3611 10.5389 27.0445 10.6667 26.6667 10.6667ZM12 16C10.5333 16 9.27779 15.4778 8.23335 14.4333C7.1889 13.3889 6.66668 12.1333 6.66668 10.6667C6.66668 9.2 7.1889 7.94444 8.23335 6.9C9.27779 5.85556 10.5333 5.33333 12 5.33333C13.4667 5.33333 14.7222 5.85556 15.7667 6.9C16.8111 7.94444 17.3333 9.2 17.3333 10.6667C17.3333 12.1333 16.8111 13.3889 15.7667 14.4333C14.7222 15.4778 13.4667 16 12 16ZM1.33335 24V22.9333C1.33335 22.1778 1.52779 21.4833 1.91668 20.85C2.30557 20.2167 2.82224 19.7333 3.46668 19.4C4.84446 18.7111 6.24446 18.1944 7.66668 17.85C9.0889 17.5056 10.5333 17.3333 12 17.3333C13.4667 17.3333 14.9111 17.5056 16.3333 17.85C17.7556 18.1944 19.1556 18.7111 20.5333 19.4C21.1778 19.7333 21.6945 20.2167 22.0833 20.85C22.4722 21.4833 22.6667 22.1778 22.6667 22.9333V24C22.6667 24.7333 22.4056 25.3611 21.8833 25.8833C21.3611 26.4056 20.7333 26.6667 20 26.6667H4.00002C3.26668 26.6667 2.63891 26.4056 2.11668 25.8833C1.59446 25.3611 1.33335 24.7333 1.33335 24ZM4.00002 24H20V22.9333C20 22.6889 19.9389 22.4667 19.8167 22.2667C19.6945 22.0667 19.5333 21.9111 19.3333 21.8C18.1333 21.2 16.9222 20.75 15.7 20.45C14.4778 20.15 13.2445 20 12 20C10.7556 20 9.52224 20.15 8.30002 20.45C7.07779 20.75 5.86668 21.2 4.66668 21.8C4.46668 21.9111 4.30557 22.0667 4.18335 22.2667C4.06113 22.4667 4.00002 22.6889 4.00002 22.9333V24ZM12 13.3333C12.7333 13.3333 13.3611 13.0722 13.8833 12.55C14.4056 12.0278 14.6667 11.4 14.6667 10.6667C14.6667 9.93333 14.4056 9.30555 13.8833 8.78333C13.3611 8.26111 12.7333 8 12 8C11.2667 8 10.6389 8.26111 10.1167 8.78333C9.59446 9.30555 9.33335 9.93333 9.33335 10.6667C9.33335 11.4 9.59446 12.0278 10.1167 12.55C10.6389 13.0722 11.2667 13.3333 12 13.3333Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
}

const OperationRoomTabletV1 = ({
  modal,
  setModal,
  closingModal,
  setClosingModal,
  patientsModal,
  setPatientsModal,
  room,
  roomId,
  setRoomForPatient,
  resetProcedure,
  startTimeout,
  patientReady,
  startProcedure,
  startClosing,
  completeCleaning,
  startAdditionalTimeout,
  exitProcedure,
  setTimeEditModal,
  timeEditModal,
  skipCleaning,
  turnoverClockOff,
}) => {
  const toaster = useToaster();

  // Track WebSocket reconnections for logging and debugging
  const reconnectCount = useWebSocketReconnect();
  const prevReconnectCount = useRef(reconnectCount);

  // Log reconnection events for debugging production issues
  useEffect(() => {
    if (reconnectCount > 0 && reconnectCount !== prevReconnectCount.current) {
      console.log(`[ORTabletV1] WebSocket reconnected (count: ${reconnectCount}), subscriptions will auto-resubscribe`);
      prevReconnectCount.current = reconnectCount;
    }
  }, [reconnectCount]);

  // shouldResubscribe: true ensures subscription re-establishes after WebSocket reconnection
  const proceduresQuery = useSubscription(listProceduresSubscription, {
    variables: {
      date: format(new Date(), 'YYYY-MM-DD'),
      operationRoomId: roomId,
      isCanceled: false,
    },
    shouldResubscribe: true,
  });
  const [currentProcedure, nextProceduresInOperationRoom] = getNextScheduledProcedures(
    getProcedureCards(proceduresQuery) || []
  );

  const [nextRemainingProcedure, nextRemainingProceduresInOperationRoom] = getRemainingScheduledProcedures(
    getProcedureCards(proceduresQuery) || [],
    room?.procedureStartedAt
  );

  const [working, setWorking] = useState(false);

  useEffect(() => {
    console.log('working', working);
  }, [working]);

  const withWorking = fn => async args => {
    if (fn) {
      setWorking(true);
      await fn(args);
      setWorking(false);
    }
  };

  const { patient = {}, status } = room;
  const { physician = {}, procedureType = {}, type: patientType } = patient;
  const showModal = isShown => () => setModal(isShown);
  const showClosingModal = isShown => () => setClosingModal(isShown);

  const showPatientsModal = isShown => () => setPatientsModal(isShown);
  const createUpdatePatientStatus = id => mutate => () => mutate({ variables: { id, patientId: id } });
  const updatePatientStatus = createUpdatePatientStatus(patient.id);
  const movePatientToOR = roomId => patientId => async () => {
    if (roomId == null || patientId == null) {
      console.warn('[movePatientToOR] Invalid parameters:', { roomId, patientId });
      return;
    }
    try {
      const result = await setRoomForPatient({ variables: { id: patientId, roomId } });
      if (result?.data?.setRoomForPatient === false) {
        toaster.warning('Room change is already in progress for this patient. Please try again.');
      }
    } catch (e) {
      console.error('[movePatientToOR] Error:', e);
    }
  };
  const setPatientInOr = () => resetProcedure({ variables: { id: patient.id } });
  const updateRoomStatus = id => completeCleaning({ variables: { id } });
  const updateSkipCleaning = id => skipCleaning({ variables: { id } });
  const updateTurnoverClockOff = id => turnoverClockOff({ variables: { id } });

  const call = fn => (typeof fn === 'function' ? fn() : undefined);

  const [isHelpActive, setIsHelpActive] = useState(false);
  const [doHelp] = useMutation(setHelp, {
    onCompleted: () => {
      setIsHelpActive(true);
    },
  });

  const [doUndoHelp] = useMutation(setUndoHelp, {
    onCompleted: () => {
      setIsHelpActive(false);
    },
  });

  const handleHelp = useCallback(async () => {
    if (!patient?.id) {
      console.warn('Patient ID is not available');
      return;
    }

    if (isHelpActive) {
      await doUndoHelp({
        variables: {
          id: patient.id,
        },
      });
    } else {
      await doHelp({
        variables: {
          id: patient.id,
        },
      });
    }
  }, [doHelp, doUndoHelp, isHelpActive, patient?.id]);

  // help button handler
  useEffect(() => {
    const handleKeyPress = event => {
      if (event.key === 'h') {
        handleHelp();
      }
    };

    Mousetrap.bind('h', handleKeyPress);

    return () => {
      Mousetrap.unbind('h');
    };
  }, [handleHelp]);

  const manuallyExitProcedure = id => async () => {
    try {
      await exitProcedure({ variables: { id } });
    } catch (error) {
      console.error(error);
    } finally {
      showModal(false)();
    }
  };

  const startProcedureClosing = async () => {
    try {
      await updatePatientStatus(startClosing)();
    } catch (error) {
      console.error(error);
    } finally {
      showClosingModal(false)();
    }
  };

  const withAlertSound = sound => fn => async () => {
    try {
      // we need to play it right away, as Safari prevents autoplay
      playSound(sound, true);
      await fn();
    } catch (e) {
      console.warn('Operation failed. Not playing sound notification');
    }
  };

  const withAlertSoundPrev = withAlertSound(prevSound);
  const withAlertSoundNext = withAlertSound(nextSound);

  /**
   * Here we treat TIME_OUT_2 status as ongoing,
   * because it is not relevant to the physician.
   * It’s purpose is to record second time out.
   */
  const actions = {
    [PATIENT_STATUSES.IN_OR]: {
      nextLabel: 'Start Time Out',
      next: withAlertSoundNext(updatePatientStatus(startTimeout)),
      notificationAction: {
        action: updatePatientStatus(patientReady),
        label: 'Notify Physician',
        icon: <RingVolume />,
      },
    },
    [PATIENT_STATUSES.READY]: {
      next: withAlertSoundNext(updatePatientStatus(startTimeout)),
      nextLabel: 'Start Time Out',
      notificationAction: {},
    },
    [PATIENT_STATUSES.TIME_OUT]: {
      next: withAlertSoundNext(updatePatientStatus(startProcedure)),
      prev: withAlertSoundPrev(updatePatientStatus(setPatientInOr)),
      nextLabel: 'Start Procedure',
    },
    [PATIENT_STATUSES.ONGOING]: {
      next: withAlertSoundNext(updatePatientStatus(startClosing)),
      nextLabel: 'Start Closing',
      prev: withAlertSoundPrev(updatePatientStatus(startTimeout)),
      SubAction: withProps({
        isTimeOutActive: false,
        mutate: startAdditionalTimeout,
        patient,
      })(TimeOutAction),
    },
    [PATIENT_STATUSES.TIME_OUT_2]: {
      next: withAlertSoundNext(updatePatientStatus(startClosing)),
      nextLabel: 'Start Closing',
      prev: withAlertSoundPrev(updatePatientStatus(startTimeout)),
      SubAction: withProps({
        isTimeOutActive: true,
        mutate: startAdditionalTimeout,
        patient,
      })(TimeOutAction),
    },
    [PATIENT_STATUSES.CLOSING]: {
      next: () => {},
      fallbackButton: true,
      nextLabel: '',
      isSubtleAction: true,
      prev: withAlertSoundPrev(updatePatientStatus(startProcedure)),
    },
    [ROOM_STATUSES.CLEANING]: {
      next: () => updateRoomStatus(roomId),
      nextLabel: 'Cleaning Completed',
      isHeaderHidden: true,
      showCleaningClock: true,
    },
  };

  const handlerFor = useCallback(
    direction =>
      throttle(() => {
        call(get(actions[status], direction));
      }, 1000),
    [actions, status]
  );

  // forward button handler
  useEffect(() => {
    Mousetrap.bind('l', handlerFor('next'));
    return () => Mousetrap.unbind('l');
  }, [handlerFor]);

  // back button handler
  useEffect(() => {
    Mousetrap.bind('k', handlerFor('prev'));
    return () => Mousetrap.unbind('k');
  }, [handlerFor]);

  const classes = useStyles();
  const enteredAtTime = patientEnteredTime(patient, room);
  const timeoutTime = eventTime(PROCEDURE_STATUSES.TIME_OUT, patient);
  const procedureStartTime = eventTime(PROCEDURE_STATUSES.ONGOING, patient);
  const closingTime = eventTime(PROCEDURE_STATUSES.CLOSING, patient);

  const enteredPrepAt = patientEnteredRoomTypeTime(patient, ROOM_TYPES.PRE_OP);

  const openTimeEditModal = focusedInput => () => setTimeEditModal(focusedInput);
  const closeTimeEditModal = () => setTimeEditModal(null);

  const [isFlipRoomActive, setIsFlipRoomActive] = useState(() => isFlipRoomFn(getLogEntries(patient)));

  useEffect(() => {
    const interval = setInterval(() => {
      setIsHelpActive(isHelpFn(getLogEntries(patient)));
    }, 2000);

    return () => {
      clearInterval(interval);
    };
  }, [patient]);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsFlipRoomActive(isFlipRoomFn(getLogEntries(patient)));
    }, 2000);

    return () => {
      clearInterval(interval);
    };
  }, [patient]);

  const [doFlipRoom] = useMutation(setFlipRoom, {
    onCompleted: () => {
      setIsFlipRoomActive(true);
    },
  });

  const [doUndoFlipRoom] = useMutation(setUndoFlipRoom, {
    onCompleted: () => {
      setIsFlipRoomActive(false);
    },
  });

  const handleFlipRoom = async () => {
    if (!patient?.id) {
      console.warn('Patient ID is not available');
      return;
    }

    if (isFlipRoomActive) {
      await doUndoFlipRoom({
        variables: {
          id: patient.id,
        },
      });
    } else {
      await doFlipRoom({
        variables: {
          id: patient.id,
        },
      });
    }
  };

  useEffect(() => {
    const handleUndoHelp = async () => {
      if (status === 'Closing' && isHelpActive) {
        try {
          await doUndoHelp({
            variables: {
              id: patient?.id,
            },
          });
        } catch (error) {
          console.error('Error calling undoHelp:', error);
        }
      }
    };

    handleUndoHelp();
  }, [status, isHelpActive, doUndoHelp, patient?.id]);

  useEffect(() => {
    const handleUndoFlipRoom = async () => {
      if (status === 'AnestheticEnd' && isFlipRoomActive) {
        try {
          await doUndoFlipRoom({
            variables: {
              id: patient?.id,
            },
          });
        } catch (error) {
          console.error('Error calling undoFlipRoom:', error);
        }
      }
    };

    handleUndoFlipRoom();
  }, [status, isFlipRoomActive, doUndoFlipRoom, patient?.id]);

  if (
    !nextRemainingProcedure &&
    proceduresQuery.loading === false &&
    getNestedValue('awaitingCleanup', room) === true
  ) {
    console.log('Skipping cleaning as there are no upcoming procedures.');
    updateSkipCleaning(roomId);
  }

  if (
    !nextRemainingProcedure &&
    proceduresQuery.loading === false &&
    getNestedValue('turnoverStartedAt', room) !== null
  ) {
    console.log('Turning turnover clock off as there are no upcoming procedures.');
    updateTurnoverClockOff(roomId);
  }

  const { enableHelp, enableFlipRoom, hidePatientNotDetected } = useScreenConfiguration();

  return (
    <Fragment>
      <Root>
        {patientsModal ? (
          <PatientSelection
            handleCancel={showPatientsModal(false)}
            handlePatientClick={movePatientToOR(roomId)}
            style={{ overflow: 'auto' }}
            withRoom={true}
          />
        ) : !status ? (
          <Idle>
            {/* <AirFiltrationIndicatorTimer roomId={roomId} style={{ position: 'absolute', left: '3rem', top: '2rem' }} /> */}
            <ActionWrapper>
              <Troubleshooting />
            </ActionWrapper>
            <Illustration src={waiting} />
            <Supertitle>{room.name}</Supertitle>
            <Title style={{ margin: 0 }}>Waiting for patient</Title>
            <Subtitle style={{ marginBottom: '1em' }}>
              Once the patient enters the room, this screen will automatically show the controls.
            </Subtitle>

            {currentProcedure && (
              <Fragment>
                <Divider />

                <Box display="flex" flexDirection="column" justifyContent="center" p={2} width="100%">
                  <Fragment>
                    <Box mb={2}>
                      <Typography align="center" variant="h6" gutterBottom>
                        Upcoming Procedure
                      </Typography>
                    </Box>
                    <Box display="block" className={classes.dialogContent} width="100%">
                      <Procedure
                        onClick={undefined}
                        procedure={currentProcedure}
                        isUnassigned={false}
                        date={new Date()}
                        isPatientIconVisible={true}
                      />
                    </Box>
                  </Fragment>
                </Box>
              </Fragment>
            )}

            {/* Temporary: hidePatientNotDetected. Remove this config once no longer needed. */}
            {!hidePatientNotDetected && (
              <SubtleLink onClick={showPatientsModal(true)}>Patient not Detected? Tap Here.</SubtleLink>
            )}
          </Idle>
        ) : modal ? (
          <ExitModal
            handleConfirm={withWorking(manuallyExitProcedure(patient.id))}
            handleCancel={showModal(false)}
            working={working}
          />
        ) : closingModal ? (
          <ClosingModal
            handleConfirm={startProcedureClosing}
            handleCancel={showClosingModal(false)}
            working={working}
          />
        ) : isObject(actions[status]) ? (
          <Fragment>
            {actions[status].isHeaderHidden ? (
              <Box width="100vw" display="flex" flexDirection="column" justifyContent="center">
                <StatusWrapperAlt>
                  {/* <AirFiltrationIndicatorTimer
                    roomId={roomId}
                    style={{ position: 'absolute', left: '3rem', top: '2rem' }}
                  /> */}
                  <ProcedureProgress status={status} room={room} action={actions[status]} noicon />
                </StatusWrapperAlt>

                {actions[status].showCleaningClock && (
                  <ClockWrapper>
                    <CleaningClock room={room} />
                  </ClockWrapper>
                )}

                <ActionsAlt>
                  <MainButton onClick={withWorking(actions[status].next)} disabled={working}>
                    <WithWorking working={working} size={'4rem'}>
                      <Box fontSize={'6.5em'}>
                        <ChevronRightIcon fontSize={'inherit'} />
                      </Box>
                    </WithWorking>
                    <ButtonLabel>{actions[status].nextLabel}</ButtonLabel>
                  </MainButton>
                </ActionsAlt>

                {currentProcedure && (
                  <Fragment>
                    <Divider />

                    <Box width="100%" p={2} flexDirection="flex" direction="column">
                      <Box mb={2}>
                        <Typography align="center" variant="h6" gutterBottom>
                          Upcoming Procedure
                        </Typography>
                      </Box>
                      <Box display="block" className={classes.dialogContent}>
                        <Procedure
                          onClick={undefined}
                          procedure={currentProcedure}
                          isUnassigned={false}
                          date={new Date()}
                          isPatientIconVisible={true}
                        />
                      </Box>
                    </Box>
                  </Fragment>
                )}
              </Box>
            ) : (
              <Fragment>
                <Times>
                  {enableFlipRoom ||
                    (enableHelp && (
                      <Box mt={'4rem'} mb={'6rem'} ml={'5rem'} display="flex" style={{ gap: '1rem' }}>
                        {enableFlipRoom && (
                          <ButtonBase
                            onClick={handleFlipRoom}
                            classes={{
                              root: clsx(classes.flipRoomButton, {
                                [classes.flipRoomButtonActive]: isFlipRoomActive,
                              }),
                            }}
                          >
                            <RefreshRounded style={{ color: 'white', width: 32, height: 32 }} />
                            <div>
                              <Typography>Flip Room</Typography>
                              {isFlipRoomActive && (
                                <Typography variant="caption" style={{ opacity: 0.5 }}>
                                  Tap to turn off
                                </Typography>
                              )}
                            </div>
                          </ButtonBase>
                        )}
                        {enableHelp && (
                          <ButtonBase
                            onClick={handleHelp}
                            classes={{
                              root: clsx(classes.helpButton, {
                                [classes.helpButtonActive]: isHelpActive,
                              }),
                            }}
                          >
                            <PersonAlert style={{ color: 'white', width: 32, height: 32 }} />
                            <div>
                              <Typography>Help</Typography>
                              {isHelpActive && (
                                <Typography variant="caption" style={{ opacity: 0.5 }}>
                                  Tap to turn off
                                </Typography>
                              )}
                            </div>
                          </ButtonBase>
                        )}
                      </Box>
                    ))}
                  <div style={{ display: 'flex', flexDirection: 'column', minHeight: 'calc(25vh - 1px)' }}>
                    <Entry
                      style={{ background: 'rgba(255,255,255,.15)', flex: '1 0 auto', minHeight: 'calc(20vh - 1px)' }}
                    >
                      <LabelLarge>Time</LabelLarge>
                      <WallClock />
                    </Entry>
                  </div>
                  <Entry>
                    <TimeHeader>
                      <LabelLarge>Entered at</LabelLarge>
                      {isOrTimeActive(status, OR_TIMES_S.ENTERED_AT) && (
                        <EditTimeIcon l onClick={openTimeEditModal(OR_TIMES.ENTERED_AT)} />
                      )}
                    </TimeHeader>
                    <Value>
                      {showValueIf(
                        optionalFormat(enteredAtTime, 'HH:mm'),
                        isOrTimeActive(status, OR_TIMES_S.ENTERED_AT)
                      )}
                    </Value>
                  </Entry>
                  <Entry>
                    <TimeHeader>
                      <LabelLarge>Time Out</LabelLarge>
                      {isOrTimeActive(status, OR_TIMES_S.TIMEOUT_START) && (
                        <EditTimeIcon l onClick={openTimeEditModal(OR_TIMES.TIMEOUT_START)} />
                      )}
                    </TimeHeader>
                    <Value>
                      {showValueIf(
                        optionalFormat(timeoutTime, 'HH:mm'),
                        isOrTimeActive(status, OR_TIMES_S.TIMEOUT_START)
                      )}
                    </Value>
                  </Entry>
                  <Entry right>
                    <TimeHeader>
                      <LabelLarge>Procedure Start</LabelLarge>
                      {isOrTimeActive(status, OR_TIMES_S.PROCEDURE_START) && (
                        <EditTimeIcon l onClick={openTimeEditModal(OR_TIMES.PROCEDURE_START)} />
                      )}
                    </TimeHeader>
                    <Value>
                      {showValueIf(
                        optionalFormat(procedureStartTime, 'HH:mm'),
                        isOrTimeActive(status, OR_TIMES_S.PROCEDURE_START)
                      )}
                    </Value>
                  </Entry>
                  <Entry right>
                    <TimeHeader>
                      <LabelLarge>Closing Start</LabelLarge>
                      {isOrTimeActive(status, OR_TIMES_S.CLOSING_START) && (
                        <EditTimeIcon l onClick={openTimeEditModal(OR_TIMES.CLOSING_START)} />
                      )}
                    </TimeHeader>
                    <Value>
                      {showValueIf(
                        optionalFormat(closingTime, 'HH:mm'),
                        isOrTimeActive(status, OR_TIMES_S.CLOSING_START)
                      )}
                    </Value>
                  </Entry>
                </Times>
                <Controls>
                  <CurrentAction
                    action={actions[status]}
                    physician={physician}
                    nextProceduresInOperationRoom={nextProceduresInOperationRoom}
                    patient={patient}
                    patientType={patientType}
                    procedureType={procedureType}
                    handleExitProcedureButtonClick={showModal(true)}
                    status={status}
                    room={room}
                  />
                </Controls>
                <TimeEditModal
                  onClose={closeTimeEditModal}
                  patientId={patient.id}
                  roomId={room.id}
                  enteredAt={isOrTimeActive(status, OR_TIMES_S.ENTERED_AT) ? enteredAtTime : undefined}
                  timeoutStart={isOrTimeActive(status, OR_TIMES_S.TIMEOUT_START) ? timeoutTime : undefined}
                  procedureStart={isOrTimeActive(status, OR_TIMES_S.PROCEDURE_START) ? procedureStartTime : undefined}
                  closingStart={isOrTimeActive(status, OR_TIMES_S.CLOSING_START) ? closingTime : undefined}
                  opened={!!timeEditModal}
                  focused={timeEditModal}
                  enteredPrepAt={enteredPrepAt}
                  status={status}
                />
              </Fragment>
            )}
          </Fragment>
        ) : null}
      </Root>
      {!patientsModal && !status && <ClientUpdater />}
    </Fragment>
  );
};

OperationRoomTabletV1.defaultProps = {
  room: {},
};

OperationRoomTabletV1.propTypes = {
  room: PropTypes.object.isRequired,
};

export default compose(
  withRouter,
  mapProps(props => ({
    ...props,
    roomId: parseInt(props.match.params['operationRoomId'], 10),
  })),
  graphql(setRoomForPatient, { name: 'setRoomForPatient' }),
  graphql(resetProcedure, { name: 'resetProcedure' }),
  graphql(markAsComplete, { name: 'markAsComplete' }),
  graphql(startTimeout, { name: 'startTimeout' }),
  graphql(patientReadyInOR, { name: 'patientReady' }),
  graphql(startAdditionalTimeout, { name: 'startAdditionalTimeout' }),
  graphql(startProcedure, { name: 'startProcedure' }),
  graphql(startClosing, { name: 'startClosing' }),
  graphql(startDressingOn, { name: 'startDressingOn' }),
  graphql(completeCleaning, { name: 'completeCleaning' }),
  graphql(skipCleaning, { name: 'skipCleaning' }),
  graphql(turnoverClockOff, { name: 'turnoverClockOff' }),
  graphql(exitProcedure, { name: 'exitProcedure' }),
  graphql(opreationRoomSubscription, {
    options: ({ roomId }) => ({ variables: { roomId } }),
  }),
  mapProps(({ data, match, ...rest }) => ({
    room: isDefinedAndNotNull(data) ? data['tabletApp'] || {} : {},
    error: data.error,
    ...rest,
  })),
  mapProps(({ room, ...rest }) => {
    const transformedRoom = transformORPatients(room);

    return {
      ...rest,
      room: update(transformedRoom, 'patient', patient =>
        merge(patient, getPatientProcedureDuration(patient, transformedRoom))
      ),
    };
  }),
  mapProps(({ room, ...rest }) => ({
    ...rest,
    room: mapTabletOperationRoom(room),
  })),
  // If patient is not defined then we must set
  // status to undefined for proper rendering
  mapProps(({ room, ...rest }) => ({
    ...rest,
    room: {
      ...room,
      status: !room.patient ? undefined : room.status,
    },
  })),
  withState('modal', 'setModal', false),
  withState('closingModal', 'setClosingModal', false),
  withState('timeEditModal', 'setTimeEditModal', null),
  withState('patientsModal', 'setPatientsModal', false),
  lifecycle({
    componentDidMount() {
      const thisComponent = this;
      const synthesizeVoice = message => {
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.callback) {
          window.webkit.messageHandlers.callback.postMessage(message);
        } else {
          console.log('Synthesizing voice:', message);
        }
      };

      window.orKit = {
        async startTimeout() {
          const { room, startTimeout, startAdditionalTimeout } = thisComponent.props;
          const { patient = {}, status } = room;

          if (patient.id) {
            if (status === PATIENT_STATUSES.IN_OR) {
              try {
                await startTimeout({
                  variables: {
                    id: patient.id,
                    patientId: patient.id,
                  },
                });
                synthesizeVoice('Timeout started.');
              } catch (e) {
                console.error(e);
                synthesizeVoice('Unable to start timeout.');
              }
            } else if (status === PATIENT_STATUSES.ONGOING) {
              try {
                await startAdditionalTimeout({
                  variables: {
                    id: patient.id,
                    patientId: patient.id,
                  },
                });
                synthesizeVoice('Timeout started.');
              } catch (e) {
                console.error(e);
                synthesizeVoice('Unable to start timeout.');
              }
            } else {
              synthesizeVoice('Unable to start timeout.');
            }
          } else {
            synthesizeVoice('Unable to start timeout.');
          }
        },
        async startProcedure() {
          const { room, startProcedure } = thisComponent.props;
          const { patient = {}, status } = room;

          if (patient.id && status === PATIENT_STATUSES.TIME_OUT) {
            try {
              await startProcedure({
                variables: {
                  id: patient.id,
                  patientId: patient.id,
                },
              });
              synthesizeVoice('Procedure started.');
            } catch (e) {
              console.error(e);
              synthesizeVoice('Unable to start procedure.');
            }
          } else {
            synthesizeVoice('Unable to start procedure.');
          }
        },
        async startClosing() {
          const { room, startClosing } = thisComponent.props;
          const { patient = {}, status } = room;

          if (patient.id && status === PATIENT_STATUSES.ONGOING) {
            try {
              await startClosing({
                variables: {
                  id: patient.id,
                  patientId: patient.id,
                },
              });
              synthesizeVoice('Closing started.');
            } catch (e) {
              console.error(e);
              synthesizeVoice('Unable to start closing.');
            }
          } else {
            synthesizeVoice('Unable to start closing.');
          }
        },
        async startDressingOn() {
          const { room, startDressingOn } = thisComponent.props;
          const { patient = {}, status } = room;

          if (patient.id && status === PATIENT_STATUSES.CLOSING) {
            try {
              await startDressingOn({
                variables: {
                  id: patient.id,
                  patientId: patient.id,
                },
              });
              synthesizeVoice('Dressing started.');
            } catch (e) {
              console.error(e);
              synthesizeVoice('Unable to start dressing.');
            }
          } else {
            synthesizeVoice('Unable to start closing.');
          }
        },
        async markAsComplete() {
          const { room, markAsComplete } = thisComponent.props;
          const { patient = {}, status } = room;

          if (patient.id && status === PATIENT_STATUSES.CLOSING) {
            try {
              await markAsComplete({
                variables: {
                  id: patient.id,
                  patientId: patient.id,
                },
              });
              synthesizeVoice('Marked as complete.');
            } catch (e) {
              console.error(e);
              synthesizeVoice('Unable to mark as complete.');
            }
          } else {
            synthesizeVoice('Unable to mark as complete.');
          }
        },
        async completeCleaning() {
          const { room, completeCleaning } = thisComponent.props;
          const { status } = room;

          if (status === ROOM_STATUSES.CLEANING) {
            try {
              await completeCleaning({
                variables: {
                  id: room.id,
                },
              });
              synthesizeVoice('Cleaning completed.');
            } catch (e) {
              console.error(e);
              synthesizeVoice('Unable to complete cleaning.');
            }
          } else {
            synthesizeVoice('Unable to complete cleaning.');
          }
        },
        async skipCleaning() {
          const { room, skipCleaning } = thisComponent.props;
          const { status } = room;

          if (status === ROOM_STATUSES.CLEANING) {
            try {
              await skipCleaning({
                variables: {
                  id: room.id,
                },
              });
              synthesizeVoice('Cleaning completed.');
            } catch (e) {
              console.error(e);
              synthesizeVoice('Unable to complete cleaning.');
            }
          } else {
            synthesizeVoice('Unable to complete cleaning.');
          }
        },
        async turnoverClockOff() {
          const { room, turnoverClockOff } = thisComponent.props;
          const { status } = room;

          if (status === ROOM_STATUSES.VACANT) {
            try {
              await turnoverClockOff({
                variables: {
                  id: room.id,
                },
              });
              synthesizeVoice('Turnover Skipped.');
            } catch (e) {
              console.error(e);
              synthesizeVoice('Unable to skip turnover.');
            }
          } else {
            synthesizeVoice('Unable to skip turnover.');
          }
        },
        async exitProcedure() {
          const { room, exitProcedure } = thisComponent.props;
          const { patient = {}, status } = room;

          if (patient.id && status === PATIENT_STATUSES.IN_OR) {
            try {
              await exitProcedure({
                variables: {
                  id: patient.id || 1,
                  patientId: patient.id || 1,
                },
              });
              synthesizeVoice('Procedure exited.');
            } catch (e) {
              console.error(e);
              synthesizeVoice('Unable to exit procedure.');
            }
          } else {
            synthesizeVoice('Unable to exit procedure.');
          }
        },
      };
    },
    componentWillUnmount() {
      delete window.orKit;
    },
  })
)(OperationRoomTabletV1);
